export const ExpandIcon = () => (
  <svg viewBox='0 0 34 34' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M17.5 25L7.54071 12.25L27.4593 12.25L17.5 25Z' fill='currentColor' />
  </svg>
)
